<template>
    <div class="user">
        <div>
            <!--form表单-->
            <el-form size="small" ref="form" :model="form" label-width="200px">
<!--                <div class="common-form">平台联系电话</div>-->
<!--                <el-form-item label="平台联系电话" prop="values.platform_tel" :rules="[{required: true,pattern: /^1[3456789]\d{9}$/,message: '手机号格式不正确',trigger: 'blur'}]" >-->
<!--                    <el-input v-model="form.values.platform_tel" class="max-w460"></el-input>-->
<!--                </el-form-item>-->
                <div class="common-form">虚拟学习人数</div>
                <el-form-item label="虚拟学习人数" prop="values.students_num" :rules="[{required: true, message: '虚拟学习人数为整数',trigger: 'blur'}]" >
                    <el-input v-model="form.values.students_num" @input="inputDistanceChange" class="max-w460"></el-input>
                    <span class="tips"> 真实学习人数：{{ study_num }} </span>
                </el-form-item>
                <div class="common-form">开关</div>
                <el-form-item label="是否开启会员板块">
                    <div>
                        <el-radio v-model="form.values.is_open_member" label="1">开启</el-radio>
                        <el-radio v-model="form.values.is_open_member" label="0">关闭</el-radio>
                    </div>
                </el-form-item>
                <el-form-item label="是否开启实名认证">
                    <div>
                        <el-radio v-model="form.values.is_open_identification" label="1">开启</el-radio>
                        <el-radio v-model="form.values.is_open_identification" label="0">关闭</el-radio>
                    </div>
                </el-form-item>
                <el-form-item label="是否开启心愿">
                    <div>
                        <el-radio v-model="form.values.is_open_wish" label="1">开启</el-radio>
                        <el-radio v-model="form.values.is_open_wish" label="0">关闭</el-radio>
                    </div>
                </el-form-item>

                <div class="common-form">板块名称</div>
                <el-form-item label="活动板块名称" prop="values.index_activity_name" :rules="[{required: true,message: '请输入名称',trigger: 'blur'}]" >
                    <el-input v-model="form.values.index_activity_name" class="max-w460"></el-input>
                </el-form-item>
                <el-form-item label="心愿墙板块名称" prop="values.index_wish_name" :rules="[{required: true,message: '请输入名称',trigger: 'blur'}]" >
                    <el-input v-model="form.values.index_wish_name" class="max-w460"></el-input>
                </el-form-item>
<!--                <el-form-item label="个人中心板块名称" prop="values.index_member_name" :rules="[{required: true,message: '请输入名称',trigger: 'blur'}]" >-->
<!--                    <el-input v-model="form.values.index_member_name" class="max-w460"></el-input>-->
<!--                </el-form-item>-->
                <el-form-item label="课程板块名称" prop="values.index_course_name" :rules="[{required: true,message: '请输入名称',trigger: 'blur'}]" >
                    <el-input v-model="form.values.index_course_name" class="max-w460"></el-input>
                </el-form-item>
                <el-form-item label="投票板块名称" prop="values.index_vote_name" :rules="[{required: true,message: '请输入名称',trigger: 'blur'}]" >
                    <el-input v-model="form.values.index_vote_name" class="max-w460"></el-input>
                </el-form-item>
                <el-form-item label="视频板块名称" prop="values.index_audio_name" :rules="[{required: true,message: '请输入名称',trigger: 'blur'}]" >
                    <el-input v-model="form.values.index_video_name" class="max-w460"></el-input>
                </el-form-item>
                <el-form-item label="音频板块名称" prop="values.index_audio_name" :rules="[{required: true,message: '请输入名称',trigger: 'blur'}]" >
                    <el-input v-model="form.values.index_audio_name" class="max-w460"></el-input>
                </el-form-item>

                <div class="common-form">会员信息字段</div>
                <el-form-item label="头像">
                    <div>
                        <el-radio v-model="form.values.user_register_avatar" label="1">开启</el-radio>
                        <el-radio v-model="form.values.user_register_avatar" label="0">关闭</el-radio>
                    </div>
                </el-form-item>
                <el-form-item label="性别">
                    <div>
                        <el-radio v-model="form.values.user_register_gender" label="1">开启</el-radio>
                        <el-radio v-model="form.values.user_register_gender" label="0">关闭</el-radio>
                    </div>
                </el-form-item>
                <el-form-item label="出生日期">
                    <div>
                        <el-radio v-model="form.values.user_register_birthday" label="1">开启</el-radio>
                        <el-radio v-model="form.values.user_register_birthday" label="0">关闭</el-radio>
                    </div>
                </el-form-item>
                <el-form-item label="政治面貌">
                    <div>
                        <el-radio v-model="form.values.user_register_identity" label="1">开启</el-radio>
                        <el-radio v-model="form.values.user_register_identity" label="0">关闭</el-radio>
                    </div>
                </el-form-item>
<!--                <el-form-item label="民族">-->
<!--                    <div>-->
<!--                        <el-radio v-model="form.values.user_register_nation" label="1">开启</el-radio>-->
<!--                        <el-radio v-model="form.values.user_register_nation" label="0">关闭</el-radio>-->
<!--                    </div>-->
<!--                </el-form-item>-->
                <el-form-item label="学校/单位">
                    <div>
                        <el-radio v-model="form.values.user_register_company" label="1">开启</el-radio>
                        <el-radio v-model="form.values.user_register_company" label="0">关闭</el-radio>
                    </div>
                </el-form-item>
                <el-form-item label="班级/部门">
                    <div>
                        <el-radio v-model="form.values.user_register_dept" label="1">开启</el-radio>
                        <el-radio v-model="form.values.user_register_dept" label="0">关闭</el-radio>
                    </div>
                </el-form-item>
                <el-form-item label="工号/学号">
                    <div>
                        <el-radio v-model="form.values.user_register_student_number" label="1">开启</el-radio>
                        <el-radio v-model="form.values.user_register_student_number" label="0">关闭</el-radio>
                    </div>
                </el-form-item>
                <el-form-item label="角色">
                    <div>
                        <el-radio v-model="form.values.user_register_role" label="1">开启</el-radio>
                        <el-radio v-model="form.values.user_register_role" label="0">关闭</el-radio>
                    </div>
                </el-form-item>
                <el-form-item label="职业">
                    <div>
                        <el-radio v-model="form.values.user_register_job" label="1">开启</el-radio>
                        <el-radio v-model="form.values.user_register_job" label="0">关闭</el-radio>
                    </div>
                </el-form-item>

                <!--提交-->
                <div class="common-button-wrapper">
                    <el-button size="small" type="primary" @click="onSubmit" :loading="loading" v-auth="'/education/setting/index'">提交</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {getSetting, setSetting, getStudyNum} from '@/api/education'

    export default {
        name: 'platform-setting',
        data() {
            return {
                study_num: 0,
                /*form表单数据*/
                form: {
                    key: 'platform',
                    describe: '平台设置',
                    values: {
                        students_num: 0,
                        platform_tel: '',
                        index_activity_name: '活动',
                        index_wish_name: '心愿墙',
                        index_member_name: '个人中心',
                        index_course_name: '课程',
                        index_vote_name: '投票',
                        index_audio_name: '音频锦集',
                        index_video_name: '视频锦集',

                        is_open_member: '1', // 会员板块
                        is_open_identification: '1', // 实名认证
                        is_open_wish: '1', // 心愿

                        user_register_avatar: '1',
                        user_register_gender: '1',
                        user_register_birthday: '1',
                        user_register_identity: '1',
                        // user_register_nation: '1',
                        user_register_company: '1',
                        user_register_dept: '1',
                        user_register_student_number: '1',
                        user_register_role: '1',
                        user_register_job: '1',
                    }
                },
                /*是否正在加载*/
                loading: true,
            };
        },
        props: {},
        created() {
            this.getSet()
            this.studyNum()
        },
        methods: {
            inputDistanceChange(value, item, type) {
                value = value.replace(/[^\d]/g, '')
                this.form.values.students_num = value
            },
            //提交表单
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (valid !== false) {

                        if(this.form.values.students_num.length >= 10){
                            this.$message({
                                message: '只能输入小于10位的整数',
                                type: 'error'
                            });
                            return false;
                        }

                        this.loading = true;
                        setSetting(this.form)
                            .then(data => {
                                this.loading = false;
                                this.$message({
                                    message: '恭喜你，设置成功',
                                    type: 'success'
                                });

                            })
                            .catch(error => {
                                this.loading = false;
                            });
                    }
                })

            },
            // 获取实际学习人数
            studyNum(){
                getStudyNum().then((res)=>{
                    console.log(res, 'res')
                    this.study_num = res.data.data
                })
            },

            // 获取配置
            getSet() {
                getSetting({key: this.form.key}).then((result) => {
                    if (result.data.values) {
                        this.form.values = Object.assign(this.form.values, result.data.values)
                    }
                    this.loading = false;
                })
            },
        }
    };
</script>

<style>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/setting/part/platform.vue